const _now = Date.now
    ? Date.now
    : function() {
          return +new Date();
      };

const caf =
    window.cancelAnimationFrame ||
    window.webkitCancelAnimationFrame ||
    window.oCancelAnimationFrame ||
    window.msCancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    function(rafReference) {
        clearTimeout(rafReference);
    };

const raf =
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function(f) {
        return setTimeout(f, 1000 / 60);
    };

function each(obj, fn) {
    let key;
    for (key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            fn(key);
        }
    }
}

class Animator {
    constructor() {
        this.id = Math.random();
    }

    play(config) {
        this._timestamp = _now();
        this._duration = config.duration || 1000;
        this._intervals = config.intervals || { value: [0, 100] };
        this._easing = config.easing || (x => x);
        this._onStep = config.onStep || function() {};
        this._rafRef = null;
        this._animate();
    }

    stop() {
        if (this._rafRef) {
            caf(this._rafRef);
            this._rafRef = null;
        }
    }

    _animate() {
        const self = this;
        const step = function(timestamp) {
            // niekedy cancelAnimationFrame z magickych dovodov nezafunguje
            if (self._rafRef === null) {
                return;
            }
            const runtime = timestamp - self._timestamp;
            const progress = Math.min(runtime / self._duration, 1);
            const eased = self._easing(progress);

            const t = {};
            each(self._intervals, key => {
                const interval = self._intervals[key];
                t[key] = eased * (interval[1] - interval[0]) + interval[0];
            });
            // const transformed = eased  * (self._interval[1]-self._interval[0]) + self._interval[0];
            self._onStep(t, eased);
            if (runtime < self._duration) {
                self._rafRef = raf(() => step(_now()));
            }
        };
        self._rafRef = raf(() => step(self._timestamp));
    }

    static easeInOutExpo(pos) {
        if (pos === 0) {
            return 0;
        }
        if (pos === 1) {
            return 1;
        }
        if ((pos /= 0.5) < 1) {
            return 0.5 * Math.pow(2, 10 * (pos - 1));
        }
        return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
    }

    static easeInExpo(pos) {
        return pos === 0 ? 0 : Math.pow(2, 10 * (pos - 1));
    }

    static easeOutExpo(pos) {
        return pos === 1 ? 1 : -Math.pow(2, -10 * pos) + 1;
    }
}

export default Animator;
